// extracted by mini-css-extract-plugin
module.exports = {"author":"Author-module--author--2Yefr","author__home-button":"Author-module--author__home-button--KCjR4"};